import React from "react";
import {useSelector} from "react-redux";
import "./style.scss";

import minimunTradingDay from "../../../assets/icons/mininumTradingDays.svg";
import {Tooltip} from "antd";
import infoIcon from "../../../assets/icons/info-icon-svgrepo-com.svg";

function Statistic({value, value2, lastUpdated, challenge}) {
  const now = new Date();
  const options = {timeZoneName: "short"};
  const timeZone = new Intl.DateTimeFormat(undefined, options).formatToParts(now).find((part) => part.type === "timeZoneName").value;

  const accountsData = useSelector((state) => state.account);
  function formatAsUSD(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  }
  console.log(accountsData?.accountMetrics?.data?.plan_name, "accountsDataok");
  const accountList = accountsData?.accountList;
  const account = accountList?.data?.find((acc) => acc?.login_id === accountList?.selectedAccount?.login_id?.replace("%23", "#"));

  return (
    <div className="statistic-container">
      <div className="statistic-subcontainer">
        <h4>Statistics</h4>
        <div className="statistic_details_container">
          <div className="statistic_details_Wrapper">
            <div className="statistic_info">
              <h5>Equity</h5>
              <p>{formatAsUSD(accountsData?.accountMetrics?.data?.balance_equity?.equity)}</p>
            </div>
          </div>
          <div className="statistic_details_Wrapper">
            <div className="statistic_info">
              <h5>Balance</h5>
              <p>{formatAsUSD(accountsData?.accountMetrics?.data?.balance_equity?.balance)}</p>
            </div>
          </div>
          <div className="statistic_details_Wrapper">
            <div className="statistic_info">
              <h5>No. of trades</h5>
              <p>{accountsData?.accountMetrics?.data?.account_metrics?.number_of_trades}</p>
            </div>
          </div>
          <div className="statistic_details_Wrapper">
            <div className="statistic_info">
              <h5>Win rate</h5>
              <p>{Math.trunc(value2?.win_rate * 100) / 100}%</p>
            </div>
          </div>
          <div className="statistic_details_Wrapper">
            <div className="statistic_info">
              <h5>Account size</h5>
              <p>{challenge}</p>
            </div>
          </div>
          {accountsData?.accountMetrics?.data?.plan_name === "Instant" && accountsData?.accountMetrics?.data?.program_objectives?.best_day_profit && (
            <div className="statistic_details_Wrapper">
              <div className="statistic_info">
                <h5>Best Day Profit</h5>
                <p style={{display: "flex", alignItems: "center", gap: "5px"}}>
                  {formatAsUSD(accountsData?.accountMetrics?.data?.program_objectives?.best_day_profit)}
                  <Tooltip
                    title={accountsData?.accountMetrics?.data?.program_objectives?.best_day_date || "No date available"}
                    placement="top"
                    color="#fff"
                  >
                    <img
                      src={infoIcon}
                      alt="info"
                      style={{
                        width: 16,
                        height: 16,
                        cursor: "pointer",
                        marginLeft: 6,
                        background: "#fff",
                        borderRadius: "50%",
                        border: "1px solid #2091eb",
                        verticalAlign: "middle",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Tooltip>
                </p>
              </div>
            </div>
          )}
          {account?.next_payout_date && (
            <div className="statistic_details_Wrapper">
              <img
                src={minimunTradingDay}
                alt=""
              />
              <div className="statistic_info">
                <h5>Next payout date</h5>
                <p>{(account && account?.next_payout_date) || "NA"}</p>
              </div>
            </div>
          )}
          {account?.consistency && (
            <div className="statistic_details_Wrapper">
              <div className="statistic_info">
                <h5>Consistency</h5>
                <p>{(account && account?.consistency + "%") || "NA"}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Statistic;
